import styles from './styles.module.scss';
import { FOOTER } from 'components/AiMode/constants';
import { Horizontal } from 'packages/radiant-react/layout';
import { Colors, Typography } from 'packages/radiant-react/typography';

export const ChatFooter = () => {
  return (
    <Horizontal className={styles['chat-footer']}>
      <Typography
        variant="footnote"
        color={Colors.grayLight}
        className={styles['chat-footer-disclaimer-text']}
      >
        {FOOTER.DISCLAIMER}
      </Typography>
      {/* In the embedded mode, <Link> is not working as expected. So using <a> instead. */}
      <a
        data-testid="link"
        href={FOOTER.LEARN_MORE_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className={styles['chat-footer-learn-more-link']}
      >
        {FOOTER.LEARN_MORE_TEXT}
      </a>
    </Horizontal>
  );
};
